export default __webpack_public_path__ + "static/media/Button-Check-selected.bd34cb42.svg";